import CheckedIcon from '@images/icons/create-recipient-checked.svg?react'

import cn from 'classnames'
import type { ReactNode } from 'react'

import './customRecipientCheckbox.scss'

type CustomCheckboxProps = {
  icon: ReactNode
  caption: ReactNode
  checked: boolean
  disabled?: boolean
  onClick: () => void
}

const CustomCheckbox = ({ icon, caption, checked, disabled, onClick }: CustomCheckboxProps) => {
  const handleClick = () => !disabled && onClick()

  return (
    <div className={cn('custom-recipient-checkbox-wrapper', { checked, disabled })} onClick={handleClick}>
      <div className='icon'>{icon}</div>
      <div className='caption'>{caption}</div>
      {checked && <CheckedIcon />}
    </div>
  )
}

export default CustomCheckbox
